<template>
    <div class="message">
        <div class="info_box">
            <div class="fliter">
                <div class="fliter_item" style="width: 200px">
                    <el-input v-model="paginationData.projectNo" placeholder="请输入项目编号" style="width: 200px" clearable>
                    </el-input>
                </div>
                <div class="fliter_item" style="width: 200px">
                    <el-input v-model="paginationData.projectName" placeholder="请输入项目名称" style="width: 200px" clearable>
                    </el-input>
                </div>
                <div class="fliter_item">
                    <el-button type="primary" icon="Search" @click="searchData">检索</el-button>
                </div>
                <div class="fliter_item">
                    <el-button plain icon="RefreshLeft" @click="resetData">重置</el-button>
                </div>
            </div>
            <el-table ref="multipleTable" :data="tableData" stripe border v-loading="loading">
                <el-table-column type="index" label="序号" width="80"></el-table-column>
                <el-table-column prop="projectName" label="项目名"></el-table-column>
                <el-table-column prop="projectNo" label="项目编号"></el-table-column>
                <el-table-column label="审核状态">
                    <template #default="scope">
                        <el-tag v-if="scope.row.status == '1'" type="info">待审核</el-tag>
                        <el-tag type="primary" v-if="scope.row.status == '2'">审核中</el-tag>
                        <el-tag type="success" v-if="scope.row.status == '3'">审核通过</el-tag>
                        <el-tag type="danger" v-if="scope.row.status == '4'">驳回</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="报名时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="200px">
                    <template #default="scope">
                        <el-link type="primary" @click="dataDetail(scope.$index, scope.row)">查看详情</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap flex_end">
                <el-pagination background :current-page="paginationData.pageNum"
                    :page-size.sync="paginationData.pageSize" @current-change="handleCurrentChange"
                    layout="total, prev, pager, next" :total="paginationData.total"></el-pagination>
            </div>
        </div>

        <el-drawer v-model="dialogResubmit" title="保证金详情" direction="rtl">
            <el-descriptions class="margin-top" :column="1" :size="size" border>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            绑定账户
                        </div>
                    </template>
                    {{ bondDetails.nickName }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            项目编号
                        </div>
                    </template>
                    {{ bondDetails.projectNo }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            项目名称
                        </div>
                    </template>
                    {{ bondDetails.projectName }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            付款人
                        </div>
                    </template>
                    {{ bondDetails.userName }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            保证金
                        </div>
                    </template>
                    {{ bondDetails.bondFee }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            是否退回保证金
                        </div>
                    </template>
                    <el-tag size="small" v-if="bondDetails.returnFeeFlag == 'Y'">是</el-tag>
                    <el-tag size="small" v-if="bondDetails.returnFeeFlag == 'N'">否</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            付款账户名称
                        </div>
                    </template>
                    {{ bondDetails.bankAccountName }}
                </el-descriptions-item>
<!--                <el-descriptions-item>-->
<!--                    <template #label>-->
<!--                        <div class="cell-item">-->
<!--                            付款开户行名称-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    {{ bondDetails.bankName }}-->
<!--                </el-descriptions-item>-->
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            付款银行卡号
                        </div>
                    </template>
                    {{ bondDetails.bankNo }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            证件号
                        </div>
                    </template>
                    {{ bondDetails.userCode }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            联系电话
                        </div>
                    </template>
                    {{ bondDetails.userPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template #label>
                        <div class="cell-item">
                            付款时间
                        </div>
                    </template>
                    {{ bondDetails.bondFeeTime }}
                </el-descriptions-item>
<!--                <el-descriptions-item>-->
<!--                    <template #label>-->
<!--                        <div class="cell-item">-->
<!--                            备注-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    {{ bondDetails.remark }}-->
<!--                </el-descriptions-item>-->
                <el-descriptions-item v-for="(item, index) in bondDetails.fileList" :key="index">
                    <template #label>
                        <div class="cell-item">
                            附件列表
                        </div>
                    </template>
                    {{ item.fileName }}
                </el-descriptions-item>
            </el-descriptions>
        </el-drawer>
    </div>
</template>

<script>
import { bondList, bondDetail } from "@/utils/api";
import signupCom from "@/components/signupCom.vue";
var moment = require("moment");
export default {
    components: {
        signupCom
    },
    data() {
        return {
            loading: false,
            tableData: [],
            paginationData: {
                total: 0,
                pageNum: 1,
                pageSize: 10,
                projectNo: "",
                projectName: "",
                createBy: localStorage.userId,
            },
            dialogResubmit: false,
            bondDetails: {},
        };
    },
    computed: {},
    mounted() {
        this.getData();
    },
    methods: {
        // 查看详情
        async dataDetail(index, row) {
            let res = await bondDetail({ id: row.id });
            if (res.code == 200) {
                this.dialogResubmit = true;
                this.bondDetails = res.data;
            }
        },
        async searchData() {
            this.paginationData.pageNum = 1;
            this.getData();
        },
        resetData() {
            this.paginationData.projectNo = "";
            this.paginationData.projectName = "";
            this.paginationData.pageNum = 1;
            this.getData();
        },
        async getData() {
            let res = await bondList(this.paginationData);
            if (res.code == 200) {
                this.loading = false;
                this.tableData = res.data.rows;
                this.paginationData.total = Number(res.data.total);
            }
        },
        handleCurrentChange(num) {
            this.paginationData.pageNum = num;
            this.getData();
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm");
        },
        formatTime(date) {
            return moment(date).format("YYYY-MM-DD HH:mm");
        },
        async handleEdit(index, row) { },
    },
};
</script>

<style lang="scss" scoped>
.detail_box {
    padding: 25px;
}

.cert_img {
    margin-top: 25px;

    img {
        display: block;
        width: 100%;
    }
}
</style>